<template>
  <div class="cohort-fields">
    <div class="patient-value-item" v-if="shouldDraw('gender')">
      <!-- <div class="patient-value-icon gender"></div> -->
      <span class="patient-value">{{patient.cases ? patient.cases[0].tags[1].value : patient.tags[1].value}}</span>
      <!-- <span class="patient-value">{{(getBaseField(patient,'female/male ratio') || getBaseField(patient,'Is Male'))?'Male':'Female'}}</span> -->
    </div>
    <div
      class="patient-value-item"
      v-if="shouldDraw('conditions') && getNonBaseField(patient,'conditions')"
    >
      <div class="patient-value-icon condition"></div>
      <span class="patient-value">{{getNonBaseField(patient,'conditions').join(', ')}}</span>
    </div>
    <div
      class="patient-value-item"
      v-if="shouldDraw('diseases') && getNonBaseField(patient,'diseases')"
    >
      <div class="patient-value-icon desease"></div>
      <span class="patient-value">{{getNonBaseField(patient,'diseases').join(', ')}}</span>
    </div>
    <div
      class="patient-value-item"
      v-if="shouldDraw('treatments') && getNonBaseField(patient,'treatments')"
    >
      <div class="patient-value-icon treatment"></div>
      <span class="patient-value">{{getNonBaseField(patient,'treatments').join(', ')}}</span>
    </div>
  </div>
</template>

<script>
import {getGeneralCharacteristicField, getOtherSubjectFields} from '@/utils'
const FIELDS_DEF = ['gender','conditions','diseases','treatments']
export default {
  props: ['patient','include','exclude'],
  computed: {
    fieldsToDraw () {
      if(this.include) return FIELDS_DEF.filter((f)=>this.include.indexOf(f)>=0)
      else if(this.exclude) return FIELDS_DEF.filter((f)=>this.exclude.indexOf(f)<0)
      else return FIELDS_DEF
    }
  },
  methods:{
    shouldDraw (field) {
      return this.fieldsToDraw.indexOf(field)>=0
    },
    getBaseField (patient,field){
      return getGeneralCharacteristicField(patient,field)
    },
    getNonBaseField (patient, field){
      return getOtherSubjectFields(patient,field)
    }
  }
}
</script>

<style scoped lang="stylus">
.cohort-fields
  .patient-value-item
    align-items: center
    display: flex
    margin-right: 15px

    &:not(:last-child)
      margin-bottom: 5px

    .patient-value-icon
      margin-right: 7px

      &.gender
        m-icon("patient-value-dark", 10)

      &.desease
        m-icon("patient-value-dark", 10)

      &.condition
        m-icon("patient-value-dark", 10)

      &.treatment
        m-icon("patient-value-dark", 10)

    .patient-value
      color: $gull-gray
      m-font-size(12, 14)
</style>